module.exports = __webpack_public_path__ + "static/media/by.9b65127c.svg";